import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, Target, CheckCircle2 } from 'lucide-react';
import { recommendations } from '../../../data/comprehensiveFindingsData';
import './Recommendations.css';

const Recommendations: React.FC = () => {
  return (
    <div className="tmf-recommendations">
      <div className="tmf-recommendations-grid">
        {recommendations.map((recommendation, index) => (
          <motion.div
            key={recommendation.id}
            className="tmf-recommendation-card"
            initial={{ opacity: 0, y: 60, scale: 0.95 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true }}
            transition={{
              duration: 0.6,
              delay: index * 0.1,
              ease: 'backOut',
            }}
            whileHover={{ scale: 1.03, y: -6 }}
          >
            {/* Number badge */}
            <div className="tmf-rec-number-badge">
              <span className="tmf-rec-number">{recommendation.id}</span>
            </div>

            {/* Icon */}
            <div className="tmf-rec-icon-wrapper">
              <Lightbulb className="tmf-rec-icon" size={28} />
            </div>

            {/* Title and description */}
            <h4 className="tmf-rec-title">{recommendation.title}</h4>
            <p className="tmf-rec-description">{recommendation.description}</p>

            {/* Key actions */}
            {recommendation.keyActions.length > 0 && (
              <div className="tmf-rec-actions">
                <div className="tmf-rec-actions-label">Key Actions:</div>
                <ul className="tmf-rec-actions-list">
                  {recommendation.keyActions.map((action, actionIndex) => (
                    <li key={actionIndex} className="tmf-rec-action-item">
                      <CheckCircle2 className="tmf-rec-check-icon" size={14} />
                      <span>{action}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Impact area badge */}
            <div className="tmf-rec-impact-area">
              <Target className="tmf-rec-impact-icon" size={14} />
              <span>{recommendation.impactArea}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Recommendations;
